import { inject, observer } from 'mobx-react';
import React from 'react';

import { AnalyticsConsumerProps, withAnalytics } from '../hoc/withAnalytics';
import Store from '../store';
import ProductStore from '../store/productStore';
import UIStore from '../store/uiStore';
import UserStore from '../store/userStore';

import HomePage from './HomePage';

type InjectedProps = {
  atlOrigin: string;
  productStore: ProductStore;
  uiStore: UIStore;
  userStore: UserStore;
  utmSource: string;
} & AnalyticsConsumerProps;

@observer
class Application extends React.Component<InjectedProps> {
  componentWillMount() {
    this.props.productStore.getProductsAndJoinableSites(this.props.analytics);
  }

  render() {
    return <HomePage atlOrigin={this.props.atlOrigin} utmSource={this.props.utmSource} />;
  }
}

export default inject(({ productStore, userStore, uiStore }: Store) => ({
  productStore,
  uiStore,
  userStore,
}))(withAnalytics(Application));
